import { Component, EventEmitter, Input, Output, computed } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertComponent, ModalComponent, TableComponent } from '@tecalisdev/infinity';
import { NOT_AVAILABLE_DISPLAY } from '../../../../../../core/utils/utils';

interface IBankCompareRow {
	clickValue: string;
	notification: boolean;
	cells: { label: string }[];
}

@Component({
	selector: 'app-operation-detail-tabs-checks-financial-evaluation-bank-modal',
	imports: [TranslatePipe, ModalComponent, AlertComponent, TableComponent],
	templateUrl: './bank-modal.component.html',
	styleUrl: './bank-modal.component.scss',
})
export class OperationDetailTabsChecksFinancialEvaluationBankModalComponent {
	@Input() isVisible = false;
	@Input() evaluatedIban = '';
	@Input() registryIban = '';
	@Output() closeEvent = new EventEmitter<void>();

	public hasMismatch = computed(() => {
		if (!this.evaluatedIban || !this.registryIban) return false;
		return this.normalize(this.evaluatedIban) !== this.normalize(this.registryIban);
	});

	public rows = computed<IBankCompareRow[]>(() => [
		{
			clickValue: '0',
			notification: this.hasMismatch(),
			cells: [
				{ label: 'IBAN' },
				{ label: this.maskIban(this.evaluatedIban) || NOT_AVAILABLE_DISPLAY },
				{ label: this.maskIban(this.registryIban) || NOT_AVAILABLE_DISPLAY },
			],
		},
	]);

	public close(): void {
		this.closeEvent.emit();
	}

	private normalize(value: string): string {
		return value.replace(/\s+/g, '').trim().toUpperCase();
	}

	private maskIban(value: string): string {
		const raw = value.replace(/\s+/g, '');
		if (!raw) return '';
		if (raw.length <= 4) return raw;
		return `**** **** **** ${raw.slice(-4)}`;
	}
}
